import capitalize from 'lodash/capitalize';
import clamp from 'lodash/clamp';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import groupBy from 'lodash/groupBy';
import isEqual from 'lodash/isEqual';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import noop from 'lodash/noop';
import omit from 'lodash/omit';
import partial from 'lodash/partial';
import throttle from 'lodash/throttle';
import uniqueId from 'lodash/uniqueId';

export {
    noop,
    omit,
    clamp,
    groupBy,
    partial,
    debounce,
    throttle,
    uniqueId,
    isString,
    capitalize,
    isEqual,
    isFunction,
    cloneDeep,
};
